import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
// core components
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import SimpleReactValidator from "simple-react-validator";
import { validatePassword } from "../../../utils/validate";

import toastr from "toastr";
import { hist } from "../../..";

import axios from "../../../config/axios";
import loaderIcon from "assets/img/loader.gif";

toastr.options = {
  closeButton: true
};

const validationStyle = {
  color: "red"
};

// const ITEM_HEIGHT = 48
// const ITEM_PADDING_TOP = 8
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250
//     }
//   }
// }
const { options } = toastr;
options.preventDuplicates = false;
class AddUser extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      action: "add",
      name: "",
      email: "",
      organisation: "",
      designation: "",
      industry: "",
      contact_no: "",
      password: "",
      department: "",
      loading: false,
      extData: [],
      mobileExt: ""
    };
  }

  componentDidMount() {
    axios
    .get(`users/countrycodeextensions`)
    .then(res => {
      if (res.status === 200) {
        let extData = res.data.data;
        console.log(res.data.data,'extData in compdidmount');
        this.setState({
          ...this.state,
          extData : extData
        })
      }
    })
    .catch(error => toastr.error("Something wrong happened!"));
  }

  inputHandler = event => {
    const { name, value } = event.target;
    if (name == "contact_no" && value.length > 12) {
      toastr.error("Max 12 Digits Mobile No. is allowed!");
    } else if (name == "password" && value.length > 20) {
      toastr.error("Max 20 Character Password is allowed!");
    } else {
      this.setState({ [name]: value });
    }
  };

  submitForm = () => {
    const {
      name,
      email,
      organisation,
      designation,
      industry,
      contact_no,
      password,
      loading,
      mobileExt
    } = this.state;

    const requestBody = {
      name: name,
      email: email,
      organisation: organisation,
      designation: designation,
      industry: industry,
      mobile: contact_no,
      password: password,
      extension:mobileExt,
      user_type: 4
    };

    if (this.validator.allValid()) {
      if (validatePassword(password)) {
        this.setState({ loading: true });
        axios
          .put("users/addnewuser", requestBody)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              toastr.success("User Added Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch(error => {
            this.setState({ loading: false });
            toastr.error(error.response.data.message);
          });
      } else {
        toastr.error(
          "Password must be between 12-20 characters</br>Must satisfy any two of four categories</br>1.Contains Uppercase Alphabet(A-Z)</br>2.Contains Lowercase Alphabet(a-z)</br>3.Contains digits(0-9)</br>4.Contains splChars(!@#$%^&*)"
        );
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  exthandler =(e)=>{
    let mobileExt =  e.target.value;
    this.setState({
      mobileExt
    })
  }
  render() {
    const { classes } = this.props;

    const {
      name,
      email,
      organisation,
      designation,
      industry,
      contact_no,
      password,
      department,
      loading,
      extData
    } = this.state;
    console.log((extData),'extData in render')
    return (
      <div className="add-category-form user_management_main">
        <Card
          // className={classes.card}
          style={{ overflow: "-webkit-paged-x" }}
        >
          {loading ? (
            <div className="loader_icon">
              <img src={loaderIcon} />
            </div>
          ) : (
            <React.Fragment>
              <CardContent>
                <form>
                  <GridContainer>
                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        name="name"
                        label="Name*"
                        type="text"
                        fullWidth
                        value={name}
                        onChange={this.inputHandler}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "name",
                            name,
                            "required|min:3"
                          )}
                        </span>
                      }
                    </GridItem>
                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="email"
                        name="email"
                        label="Email*"
                        type="email"
                        fullWidth
                        value={email}
                        onChange={this.inputHandler}
                        autoComplete="off"
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "email",
                            email,
                            "required|email"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="password"
                        name="password"
                        label="Password*"
                        type="text"
                        fullWidth
                        value={password}
                        onChange={this.inputHandler}
                        autoComplete="off"
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "password",
                            password,
                            "required|min:12"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="organisation"
                        name="organisation"
                        label="Organisation*"
                        type="text"
                        fullWidth
                        value={organisation}
                        onChange={this.inputHandler}
                        autoComplete="off"
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "organisation",
                            organisation,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="designation"
                        name="designation"
                        label="Designation*"
                        type="text"
                        fullWidth
                        value={designation}
                        onChange={this.inputHandler}
                        autoComplete="off"
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "designation",
                            designation,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="industry"
                        name="industry"
                        label="Industry*"
                        type="text"
                        fullWidth
                        value={industry}
                        onChange={this.inputHandler}
                        autoComplete="off"
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "industry",
                            industry,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>

                    <GridItem md={12}>
                      <div className="mobile_number">
                        <span>
                          <select onChange={(e)=> this.exthandler(e)}>
                            {extData && extData.map((item=>
                              <option value={item}>{item.country_code}</option>
                              ))}
                          </select>
                          </span>
                        <TextField
                          autoFocus
                          margin="dense"
                          id="contact_no"
                          name="contact_no"
                          label="Contact No*"
                          type="number"
                          fullWidth
                          value={contact_no}
                          onChange={this.inputHandler}
                          autoComplete="off"
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "contact_no",
                              contact_no,
                              "required"
                            )}
                          </span>
                        }
                      </div>
                    </GridItem>
                    {/* <GridItem md={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="department"
                    name="department"
                    label="Department*"
                    type="text"
                    fullWidth
                    value={department}
                    onChange={this.inputHandler}
                    autoComplete="off"
                  />
                  {
                    <span style={validationStyle}>
                      {this.validator.message(
                        "department",
                        department,
                        "required"
                      )}
                    </span>
                  }
                </GridItem> */}
                  </GridContainer>
                </form>
              </CardContent>

              <CardActions style={{ float: "right" }}>
                <Button
                  variant="contained"
                  color="iseas"
                  onClick={this.submitForm}
                >
                  Submit
                </Button>
              </CardActions>
            </React.Fragment>
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(extendedFormsStyle)(AddUser));



// WEBPACK FOOTER //
// ./src/views/ISEAS/UserManagement/AddManageUsers.jsx